import { Controller } from "@hotwired/stimulus"

// Keeps one value per group of selects: an option picked in one row is disabled in the
// others (a report records each Werkzeug once). Rows removed through nested-form stay in
// the DOM hidden, so only visible rows count. The server validation is the real guard;
// this only saves a round trip.
export default class extends Controller {
  static targets = ["select"]

  selectTargetConnected() {
    this.sync()
  }

  selectTargetDisconnected() {
    this.sync()
  }

  sync() {
    const live = this.selectTargets.filter((select) => !this.removed(select))
    live.forEach((select) => {
      const takenElsewhere = new Set(
        live.filter((other) => other !== select && other.value).map((other) => other.value),
      )
      let changed = false
      for (const option of select.options) {
        // Never disable a select's own pick: a disabled selected option is not submitted,
        // so two rows holding the same value (a re-rendered form) would both send nothing.
        const disabled = option.value !== "" && !option.selected && takenElsewhere.has(option.value)
        if (option.disabled !== disabled) {
          option.disabled = disabled
          changed = true
        }
      }
      // Wrapped by the `select` controller (SlimSelect), which snapshots its options.
      if (changed)
        this.application.getControllerForElementAndIdentifier(select, "select")?.refresh()
    })
  }

  removed(select) {
    const row = select.closest(".nested-fields")
    return row?.style.display === "none"
  }
}
